import React, { useEffect, useState, FC } from "react";
import { Link } from "react-router-dom";
import { playPlaylist } from "../../store/actions/queue";
import { connect } from "react-redux";
import { storage } from "../../firebase";
import PlaylistDrop from "../layout/dropdown/PlaylistDrop";
import { Playlist } from "../../models/playlist";

interface Props {
  playlist: Playlist;
  playPlaylist: Function;
}

const MultiCard: FC<Props> = ({
  playlist,

  playPlaylist,
}) => {
  const [rep, setRep] = useState("");
  const {
    title,
    tracks,
    id,
    tag,
    user: { username },
  } = playlist;

  useEffect(() => {
    let mounted = true;
    let swc = tracks.find((song) => song.covername);

    if (swc) {
      storage
        .ref(`covers/${swc.uid}${swc.covername}`)
        .getDownloadURL()
        .then((url) => {
          if (mounted) {
            setRep(url);
          }
        });
    }

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      uk-scrollspy="cls: uk-animation-slide-left uk-animation-fade"
      className={`playlist-item uk-card uk-background-blend-multiply uk-animation-fast uk-background-cover ${tag}`}
    >
      <div className="plc">
        <span></span>
        <span uk-tooltip="title: view playlist">
          <Link
            to={`/pl/${id}`}
            style={{ color: `var(--text-color) !important` }}
          >
            <i className="material-icons-outlined">queue_music</i>
          </Link>
        </span>
      </div>
      <div>
        <div className="plinfo">
          <div
            className="plimg"
            style={{ background: rep ? `url(${rep})` : "" }}
          ></div>
          <div className="pltitle">{title}</div>
          <div>By @{username}</div>
          <div className="pltracks"> {tracks.length} tracks</div>
        </div>
        <div className="plactions">
          <span
            onClick={() => {
              playPlaylist(tracks);
            }}
          >
            <i className="material-icons">play_arrow</i>
            {/* <Play /> */}
          </span>
          <span uk-toggle="target: #plactions-modal">
            <span>
              <i className="material-icons">more_horiz</i>
            </span>
            <PlaylistDrop tracks={tracks} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { playPlaylist })(MultiCard);
